if (!window.BookNookCommunityVideoInitialized) {
  window.BookNookCommunityVideoInitialized = true;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = new Set();

  const loadVideo = (video) => {
    if (video.dataset.loaded === 'true') return;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.load();
    video.dataset.loaded = 'true';
  };

  const playVideo = (video) => {
    if (reduceMotion.matches) return;

    loadVideo(video);
    video.play().catch(() => {});
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-bn-community-video]').forEach((video) => {
      if (videos.has(video)) return;
      videos.add(video);
      playVideo(video);
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  reduceMotion.addEventListener('change', (event) => {
    videos.forEach((video) => {
      if (event.matches) {
        video.pause();
      } else {
        playVideo(video);
      }
    });
  });
}
